import React from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "../../Common/SideBar";

export default function EmployeeSidebar() {
  const location = useLocation();

  const menuItems = [
    {
      label: "ADD",
      icon: "icon-user-follow",
      link: "/emp/add",
      children: [],
    },
    {
      label: "VIEW",
      icon: "icon-list",
      link: "/emp/op",
      children: [],
    },
    {
      label: "TRASH",
      icon: "icon-trash",
      link: "/emp/trash/op",
      children: [],
    },
    {
      label: "HR",
      icon: "icon-people",
      link: "##",
      children: [
        {
          label: "ONLINE APPLICATIONS",
          link: "/emp/online-applicants",
        },
        {
          label: "DOCUMENTS",
          link: "##",
        },
        {
          label: "SCREENING & VETTING",
          link: "##",
        },
      ],
    },
  ];

  const updatedMenuItems = menuItems.map((item) => ({
    ...item,
    active:
      location.pathname.includes(item.link) ||
      item.children.some((child) => location.pathname.includes(child.link)),
  }));

  return <Sidebar menuItems={updatedMenuItems} />;
}
